import React from "react";
import Container from "src/components/common/Layout/Container";
import ArticleCardContainer from "src/components/common/ArticleCard/ArticleCardContainer";
import { Box, Typography } from "@mui/material";
import { GridSize } from "@mui/material/Grid/Grid";
import { SpecialArticleItemSchema } from "src/models/articles/getSpecialArticle";

interface BlockOfArticlesProps {
  title: string;
  footerAction?: JSX.Element;
  gridLg?: GridSize;
  lastArticlesData: SpecialArticleItemSchema[];
  href?: string;
  isLoading?: boolean;
}

const BlockOfArticles: React.FC<BlockOfArticlesProps> = ({
  title,
  footerAction,
  gridLg,
  isLoading,
  lastArticlesData,
}) => {
  return (
    <Container paddingTop={5.5} paddingBottom={5.5}>
      <Typography variant="h3" component="h1" mb={2}>
        {title}
      </Typography>
      <ArticleCardContainer
        isLoading={isLoading}
        gridLg={gridLg}
        spacing={1}
        articles={lastArticlesData}
      />
      <Box
        marginTop={3.5}
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        {footerAction}
      </Box>
    </Container>
  );
};

export default BlockOfArticles;
